export default [
// 巨擎 兔年尊享包微信预览 先支付后签约-预览版
//     {
//         path: '/rabbitPink',
//         name: 'rabbitPink',
//         meta: {
//             title: '畅享音乐包',
//         },
//         component: () => import('@/view/juqing/rabbitEnjoyMusicPink-weixin')
//     },
    // 巨擎 兔年尊享包 先支付后签约-预览版
    // {
    //     path: '/rabbitExclusive-pay',
    //     name: 'rabbitExclusive-pay',
    //     meta: {
    //         title: '兔年尊享包',
    //     },
    //     component: () => import('@/view/juqing/rabbitExclusiveSigningPay')
    // },
//
//     // 巨擎 兔年尊享包 先签约后支付
//     {
//         path: '/rabbitExclusive',
//         name: 'rabbitExclusive',
//         meta: {
//             title: '兔年尊享包',
//         },
//         component: () => import('@/view/juqing/rabbitExclusiveSigning')
//     },
//     //  巨擎 畅享会员橙色版-14.9 先签约后支付
//     {
//         path: '/rabbitEnjoyOrange',
//         name: 'rabbitEnjoyOrange',
//         meta: {
//             title: '兔年畅享包',
//         },
//         component: () => import('@/view/juqing/rabbitEnjoyOrange')
//     },
//     // 巨擎  畅享会员粉色版-14.9 先签约后支付
//     {
//         path: '/rabbitEnjoyMusicPink',
//         name: 'rabbitEnjoyMusicPink',
//         meta: {
//             title: '畅享音乐包',
//         },
//         component: () => import('@/view/juqing/rabbitEnjoyMusicPink')
//     },
//     // 巨擎  会员月月领-14.9 先签约后支付
//     {
//         path: '/rabbitEquity01',
//         name: 'rabbitEquity01',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceive')
//     },
//     // 巨擎  会员月月领不加话费 19.99先签约后支付
//     {
//         path: '/rabbitEquity02',
//         name: 'rabbitEquity02',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceive02')
//     },
//     //  巨擎 会员月月领-19.9-红包 先签约后支付
//     {
//         path: '/vipEnjoyWrap',
//         name: 'vipEnjoyWrap',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipEnjoyWrap')
//     },
//     //  巨擎 会员月月领-19.9-红包 先签约后支付
//     {
//         path: '/rabbitEquity01RedEnvelope',
//         name: 'rabbitEquity01RedEnvelope',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceiveRedEnvelope')
//     },
//     // 巨擎  畅享会员原色版19.99 先签约后支付
//     {
//         path: '/vipMonthMonthReceiveYuan',
//         name: 'vipMonthMonthReceiveYuan',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceiveYuan')
//     },
//     // 巨擎  畅享会员原色版-产品价格调整到产品说明19.99 先签约后支付
//     {
//         path: '/vipMonthMonthReceiveYuan-price',
//         name: 'vipMonthMonthReceiveYuan-price',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceiveYuan-price')
//     },
//     // 巨擎  畅享会员紫色版19.99 先签约后支付
//     {
//         path: '/vipMonthMonthReceivePurple',
//         name: 'vipMonthMonthReceivePurple',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMonthMonthReceivePurple')
//     },
//     // 巨擎  出行生活天天享
//     {
//         path: '/travelVipMonthMonthReceive',
//         name: 'travelVipMonthMonthReceive',
//         meta: {
//             title: '出行生活天天享',
//         },
//         component: () => import('@/view/juqing/travelVipMonthMonthReceive')
//     },
//     // 巨擎  出行生活天天享绿色
//     {
//         path: '/travelVipMonthMonthReceiveGreen',
//         name: 'travelVipMonthMonthReceiveGreen',
//         meta: {
//             title: '出行生活天天享',
//         },
//         component: () => import('@/view/juqing/travelVipMonthMonthReceiveGreen')
//     },
//     //  巨擎  生活缴费月月领
//     {
//         path: '/lifeFeeVipMonthMonthReceive',
//         name: 'lifeFeeVipMonthMonthReceive',
//         meta: {
//             title: '生活缴费月月领',
//         },
//         component: () => import('@/view/juqing/lifeFeeVipMonthMonthReceive')
//     },
//     {
//         path: '/lifeFeeVipMonthMonthReceiveBack',
//         name: 'lifeFeeVipMonthMonthReceiveBack',
//         meta: {
//             title: '生活缴费月月领',
//         },
//         component: () => import('@/view/juqing/lifeFeeVipMonthMonthReceiveBack')
//     },
//     // 头条 热门vip会员月月领 19.99
//     {
//         path: '/vipMemberMouthMouthNeck',
//         name: 'vipMemberMouthMouthNeck',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMemberMouthMouthNeck')
//     },
//     // 会员月月领
//     {
//         path: '/vipMemberMouthMouthNeck02',
//         name: 'vipMemberMouthMouthNeck02',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/juqing/vipMemberMouthMouthNeck02')
//     },
//     // 车惠主
//     {
//         path: '/vehicleFavourHost',
//         name: 'vehicleFavourHost',
//         meta: {
//             title: '车主惠',
//         },
//         component: () => import('@/view/juqing/vehicleFavourHost')
//     },
//     // 车主惠作为投放版回跳链接
//     {
//         path: '/vehicleFavourHostBack',
//         name: 'vehicleFavourHostBack',
//         meta: {
//             title: '车主惠',
//         },
//         component: () => import('@/view/juqing/vehicleFavourHostBack')
//     },
//     // 头条 生活超市权益惠
//     {
//         path: '/lifeSupermarketEquity',
//         name: 'lifeSupermarketEquity',
//         meta: {
//             title: '生活超市权益惠',
//         },
//         component: () => import('@/view/juqing/lifeSupermarketEquity')
//     },
//
//
    // 头条 生活超市权益惠正式链接 用于对外提供 一般不动
    {
        path: '/lifeSupermarketEquityStraight',
        name: 'lifeSupermarketEquityStraight',
        meta: {
            title: '生活超市权益惠',
        },
        component: () => import('@/view/juqing/lifeSupermarketEquityStraight')
    },
    // // 兔年尊享包z 正式链接 用于对外提供 一般不动
    // {
    //     path: '/rabbitYearExclusiveEnjoyZStraight',
    //     name: 'rabbitYearExclusiveEnjoyZStraight',
    //     meta: {
    //         title: '兔年尊享包z',
    //     },
    //     component: () => import('@/view/juqing/rabbitYearExclusiveEnjoyZStraight')
    // },
    // // 巨擎 兔年尊享包V-19.99元 先签约后支付 正式版本链接 用于对外提供 一般不动
    {
        path: '/rabbitExclusiveStraight',
        name: 'rabbitExclusiveStraight',
        meta: {
            title: '兔年尊享包V-19.99元',
        },
        component: () => import('@/view/juqing/rabbitExclusiveStraight')
    },
    {
        path: '/rf',
        name: 'rf',
        meta: {
            title: '兔年尊享包',
        },
        component: () => import('@/view/juqing/rf.vue')
    },
    // // 巨擎 兔年尊享包V-19.99元 先签约后支付 作为返回链接 用于对外提供 一般不动
    // {
    //     path: '/rabbitExclusiveStraightBack',
    //     name: 'rabbitExclusiveStraightBack',
    //     meta: {
    //         title: '兔年尊享包V-19.99元',
    //     },
    //     component: () => import('@/view/juqing/rabbitExclusiveStraightBack')
    // },
    // 巨擎  出行生活天天享-19.68元 正式版本链接 用于对外提供 一般不动
    // {
    //     path: '/travelVipMonthMonthReceiveStraight',
    //     name: 'travelVipMonthMonthReceiveStraight',
    //     meta: {
    //         title: '出行生活天天享',
    //     },
    //     component: () => import('@/view/juqing/travelVipMonthMonthReceiveStraight')
    // },
    // //  巨擎  生活缴费月月领-18.88元 正式版本链接 用于对外提供 一般不动
    // {
    //     path: '/lifeFeeVipMonthMonthReceiveStraight',
    //     name: 'lifeFeeVipMonthMonthReceiveStraight',
    //     meta: {
    //         title: '生活缴费月月领',
    //     },
    //     component: () => import('@/view/juqing/lifeFeeVipMonthMonthReceiveStraight')
    // },
    // //  巨擎  生活缴费月月领-18.88元 作为正式版返回跳转链接 用于对外提供 一般不动
    // {
    //     path: '/lifeFeeVipMonthMonthReceiveStraightBack',
    //     name: 'lifeFeeVipMonthMonthReceiveStraightBack',
    //     meta: {
    //         title: '生活缴费月月领-18.88元',
    //     },
    //     component: () => import('@/view/juqing/lifeFeeVipMonthMonthReceiveStraightBack')
    // },
    // 车主惠权益-21.90元 正式版本链接 用于对外提供 一般不动
    // {
    //     path: '/vehicleFavourHostStraight',
    //     name: 'vehicleFavourHostStraight',
    //     meta: {
    //         title: '车主惠权益',
    //     },
    //     component: () => import('@/view/juqing/vehicleFavourHostStraight')
    // },
    // // 车主惠 正式版本链接返回链接 用于对外提供 一般不动
    // {
    //     path: '/vehicleFavourHostStraightBack',
    //     name: 'vehicleFavourHostStraightBack',
    //     meta: {
    //         title: '车主惠',
    //     },
    //     component: () => import('@/view/juqing/vehicleFavourHostStraightBack')
    // },
    //     // 巨擎 兔年尊享包 先签约后支付
    // {
    //     path: '/rabbitExclusiveTest',
    //     name: 'rabbitExclusiveTest',
    //     meta: {
    //         title: '兔年尊享包',
    //     },
    //     component: () => import('@/view/juqing/rabbitExclusiveSigning')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoy',
    //     name: 'dragonYearExclusiveEnjoy',
    //     meta: {
    //         title: '龙年尊享包',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoy')
    // },
    // 龙年尊享包-微信可打开
    // {
    //     path: '/dragonYearExclusiveEnjoyWeiXin',
    //     name: 'dragonYearExclusiveEnjoyWeiXin',
    //     meta: {
    //         title: '龙年尊享包',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoyWeiXin')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoyPlus',
    //     name: 'dragonYearExclusiveEnjoyPlus',
    //     meta: {
    //         title: '龙年尊享包Plus',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoyPlus')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoyPlusLogin',
    //     name: 'dragonYearExclusiveEnjoyPlusLogin',
    //     meta: {
    //         title: '龙年话费尊享包plus',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoyPlusLogin')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoyPlusStraight',
    //     name: 'dragonYearExclusiveEnjoyPlusStraight',
    //     meta: {
    //         title: '龙年尊享包Plus',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoyPlusFormal')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoyF',
    //     name: 'dragonYearExclusiveEnjoyF',
    //     meta: {
    //         title: '龙年尊享包',
    //     },
    //     component: () => import('@/view/juqing/dragonYearExclusiveEnjoyF')
    // },
    // {
    //     path: '/vs',
    //     name: 'vs',
    //     meta: {
    //         title: '会员任意选',
    //     },
    //     component: () => import('@/view/juqing/vs')
    // },
    // {
    //     path: '/ms',
    //     name: 'ms',
    //     meta: {
    //         title: '会员任意选享',
    //     },
    //     component: () => import('@/view/juqing/ms')
    // },
]
